import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=37b33275"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
import style0 from "./Landing.vue?vue&type=style&index=0&id=37b33275&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b33275')) {
      api.createRecord('37b33275', component.options)
    } else {
      api.reload('37b33275', component.options)
    }
    module.hot.accept("./Landing.vue?vue&type=template&id=37b33275", function () {
      api.rerender('37b33275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/Landing.vue"
export default component.exports